import React from 'react';
import { ReportCapexManeger } from '@app/api/relatorios';
import { Card, Col, Row } from 'antd';

interface CapexManagementSumaryProps {
    data: ReportCapexManeger;
}

const CapexManagementSumary = (props: CapexManagementSumaryProps) => {
    const { data } = props;

    return (

        <div className="negative-margins">
            <Row gutter={8}>
                <Col span={6}>
                    <Card title="Nº DE INICIATIVAS" bordered={false}>
                        {data.numeroIniciativasDoAno}
                    </Card>
                </Col>
                <Col span={6}>
                    <Card title="ORÇADO TOTAL" bordered={false}>
                        {data.capexTotalDoAnoFormat}
                    </Card>
                </Col>
                <Col span={6}>
                    <Card title="FORECAST" bordered={false}>
                        {data.realizadoDoAnoAteOMesAnteriosFormat}
                    </Card>
                </Col>
                <Col span={6}>
                    <Card title="BALANCE" bordered={false}>
                        {data.balanceFormat}
                    </Card>
                </Col>
            </Row>
        </div>

    );
};

export default CapexManagementSumary;
